import { Component } from '@angular/core';

import { Service } from '@models/service/service';

@Component({
  selector: 'app-patient-treatment-plan-tab',
  templateUrl: './patient-treatment-plan-tab.component.html',
  styleUrls: ['./patient-treatment-plan-tab.component.less'],
})
export class PatientTreatmentPlanTabComponent {
  showOverview = true;
  service: Service;
  treatmentIsFromToday: boolean;

  constructor() {}
}
